export default "__VITE_ASSET__73f2cf49__"